export default __webpack_public_path__ + "static/media/redCancel.9c1aef50.svg";